"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1({ payment_approval_cd_id, }) {
    const isAdultPlus = payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_05';
    const isAdultOnly = payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_02' || isAdultPlus;
    const is14Above = payment_approval_cd_id === 'ROOM_PAY_APPROVAL_STATUS_04';
    const { t } = (0, react_i18next_1.useTranslation)();
    const allowTypeText = isAdultOnly ? t('성인만') : is14Above ? t('만14세이상만') : '';
    if (!allowTypeText)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            display: 'flex',
            alignItems: 'center',
            height: '20px',
            padding: '0 6px',
            borderRadius: '100px',
            fontSize: '12px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            color: '#FFFFFF',
        } }, { children: allowTypeText })));
}
exports.default = default_1;
